import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { TasksBaseDataProvider } from '../dataProvider/TasksBaseDataProvider';
import { TasksDataProviderFactory } from '../factory/TasksDataProviderFactory';
import { TaskItem } from '../types';

export class TasksRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TasksDataProviderFactory;
  public dataProvider: TasksBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TasksDataProviderFactory(),
    });
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }

  public async retryRecords(records: Array<TaskItem>) {
    return this.dataProvider.retryRecords(records);
  }

  public async removeRecords(records: Array<TaskItem>) {
    return this.dataProvider.removeRecords(records);
  }

}
